import { render, staticRenderFns } from "./ModalGenerarBonos.vue?vue&type=template&id=44ada415"
import script from "./ModalGenerarBonos.vue?vue&type=script&lang=js"
export * from "./ModalGenerarBonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports